import type { CountSheetInstrumentDto, CountSheetResponseDto } from '@peritasai/types';

export class CountSheetEntity {
  readonly id: string;
  readonly trayId: string;
  readonly trayName: string;
  readonly productNumber: string | null;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly instruments: CountSheetInstrumentDto[];

  constructor(dto: CountSheetResponseDto) {
    this.id = dto.id;
    this.trayId = dto.trayId;
    this.trayName = dto.trayName;
    this.productNumber = dto.productNumber;
    this.createdAt = dto.createdAt;
    this.updatedAt = dto.updatedAt;
    this.instruments = dto.instruments;
  }

  get instrumentCount(): number {
    return this.instruments.length;
  }
}
